export default "__VITE_ASSET__BcQrRmXq__"